import { call, put, takeLatest } from "redux-saga/effects";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import * as apis from "../../network/apis/roles";
import * as actions from "./actions";
import * as types from "./types";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";

function* rolesListSaga({ payload }) {
  try {
    const response = yield call(apis.rolesList, payload);

    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;

    yield put(
      actions.rolesListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.rolesListRequest({
          params: {
            ...payload.params,
            page: +TotalPages
          }
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getModulesPermissionsSaga() {
  try {
    const response = yield call(apis.getModulesPermissionsRequest);
    yield put(
      actions.getModulesPermissionsResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* addRoleSaga({ payload }) {
  try {
    yield call(apis.addRoleRequest, payload.data);
    yield showSuccessMsg("roleAddedSuccess");
    yield payload.navigate(ROUTE_PATHS.roles);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getEditRoleDataSaga({ payload }) {
  try {
    const response = yield call(apis.getEditRoleDataRequest, payload);
    yield put(actions.getEditRoleDataResponse(response.data.Data));
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* editRoleSaga({ payload }) {
  try {
    yield call(apis.editRoleRequest, payload.data);
    yield showSuccessMsg("roleEditedSuccess");
    yield payload.navigate(ROUTE_PATHS.roles);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}
function* roleDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.roleDetails, { id: payload });

    yield put(actions.roleDetailsResponse(response.data.Data));
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* deleteRoleSaga({ payload }) {
  try {
    yield call(apis.deleteRoleRequest, payload);
    yield showSuccessMsg("roleDeletedSuccess");
    payload.src === ROUTE_PATHS.roleDetails
      ? yield payload.navigate(ROUTE_PATHS.roles)
      : yield put(
          actions.rolesListRequest({
            params: payload.params
          })
        );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* RolesSagas() {
  yield takeLatest(types.ROLES_LIST_REQUEST, rolesListSaga);
  yield takeLatest(
    types.GET_MODULES_PERMISSIONS_REQUEST,
    getModulesPermissionsSaga
  );
  yield takeLatest(types.ADD_ROLE_REQUEST, addRoleSaga);
  yield takeLatest(
    types.GET_EDIT_ROLE_DATA_REQUEST,
    getEditRoleDataSaga
  );
  yield takeLatest(types.EDIT_ROLE_REQUEST, editRoleSaga);

  yield takeLatest(types.ROLE_DETAILS_REQUEST, roleDetailsSaga);
  yield takeLatest(types.DELETE_ROLE_REQUEST, deleteRoleSaga);
}
